import { styled, TableCell } from '@mui/material';

export const TableHeadCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.grey['50'],
  color: theme.palette.primary.light,
  fontSize: '0.6875rem',
  fontWeight: 'normal'
}));
